import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { DeliveryAddress } from "../../model/delivery-address";
import { RootState } from "../store";

type DeliveryAddressState = Array<DeliveryAddress>;

const initialState: DeliveryAddressState = [];

function extractStateFromSessionStorage(): DeliveryAddressState {
	const stateFromStorage = sessionStorage.getItem("guest-delivery-address-slice");

	return stateFromStorage ? JSON.parse(stateFromStorage) : initialState;
}

function saveStateToSessionStorage(state: DeliveryAddressState) {
	sessionStorage.setItem("guest-delivery-address-slice", JSON.stringify(state));
}

export const guestDeliveryAddressSlice = createSlice({
	name: "guestDeliveryAddressSlice",
	initialState: extractStateFromSessionStorage(),

	reducers: {
		addDeliveryAddress: (state, action: PayloadAction<DeliveryAddress>) => {
			state.push({ ...action.payload, id: state.length.toString() });
            saveStateToSessionStorage(state)
		},
		updateDeliveryAddress: (state, action: PayloadAction<DeliveryAddress>) => {
			const index = state.findIndex(address => address.id === action.payload.id);
			if (index !== -1) {
				state[index] = action.payload;
			}
            saveStateToSessionStorage(state)
		},
		deleteGuestDeliveryAddress: state => {
			sessionStorage.removeItem("guest-delivery-address-slice");
			Object.assign(state, initialState);
		},
	},
});

export const { addDeliveryAddress, updateDeliveryAddress, deleteGuestDeliveryAddress } = guestDeliveryAddressSlice.actions;
export const guestDeliveryAddressSelector = (state: RootState) => state.guestDeliveryAddress;
export default guestDeliveryAddressSlice.reducer;
